import { string } from 'yup';
import axios from './index';

class BankAccountApi {
  static List = (data) => {
    let query = '?';
    if (data.userId) {
      query += `user_id=${data.userId}&`;
    }
    if (data.searchTerm) {
      query += `name=${data.searchTerm}&`;
    }
    if (data.itemsPerPage) {
      query += `limit=${data.itemsPerPage}&`;
    }
    if (data.currentPage) {
      let offset = (data.currentPage - 1) * data.itemsPerPage;
      query += `offset=${offset}&`;
    }
    if (data.sort) {
      query += `sort=${data.sort}&`;
    }
    if (data.booleanFilter) {
      query += `is_active=${data.booleanFilter}&`;
    }
    return axios.get(`${base}${query}`);
  };

  static Create = (data) => {
    console.log('bank account data-', data);
    let request = {
      account_number: String(data.accountNumber),
      holder_name: data.holderName,
      ifsc: data.ifsc,
      bank_name: data.bankName,
      bank_branch: data.bankBranch,
      account_type: data.accountType,
      default: data.default ? true : false,
      is_active: true,
      user_id: data.userId,
    };
    return axios.post(`${base}/direct`, request);
  };

  static Update = (data) => {
    console.log('data :: ', data);
    let request = {
      name: data.name,
      display_order: data.display_order || 100,
      is_active: data.is_active,
    };
    return axios.put(`${base}/${data.id}`, request);
  };

  static Delete = (data) => {
    return axios.delete(`${base}/${data.id}`);
  };
}

let base = 'customer/admin/bank-account';

export default BankAccountApi;
